import { defineStyleConfig } from "@chakra-ui/react"

export const Link = defineStyleConfig({
  baseStyle: {
    fontWeight: 600,
    textDecoration: "underline",
    color: "blue.400",
  },
})
